import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import PublicSite from "@/pages/PublicSite";
import Login from "@/pages/admin/Login";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import SintesisWizard from "@/pages/admin/SintesisWizard";
import Redactor from "@/pages/admin/Redactor";
import Articulos from "@/pages/admin/Articulos";
import Correo from "@/pages/admin/Correo";
import AgentLayout from "@/pages/admin/agent/AgentLayout";
import AgentOverview from "@/pages/admin/agent/Overview";
import AgentKnowledge from "@/pages/admin/agent/Knowledge";
import AgentContacts from "@/pages/admin/agent/Contacts";
import AgentConversations from "@/pages/admin/agent/Conversations";
import AgentProposals from "@/pages/admin/agent/Proposals";
import AgentWhatsApp from "@/pages/admin/agent/WhatsApp";
import AgentSandbox from "@/pages/admin/agent/Sandbox";
import Library from "@/pages/admin/Library";
import DocumentDetail from "@/pages/admin/DocumentDetail";
import SynthesisReader from "@/pages/SynthesisReader";
import SynthesisArchive from "@/pages/SynthesisArchive";
import ArticleReader from "@/pages/ArticleReader";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div style={{ padding: 60, textAlign: "center", fontFamily: "sans-serif" }}>Cargando…</div>;
  if (user === false) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<PublicSite />} />
          <Route path="/agente" element={<Navigate to="/" replace />} />
          <Route path="/sintesis" element={<SynthesisArchive />} />
          <Route path="/sintesis/:id" element={<SynthesisReader />} />
          <Route path="/nota/:id" element={<ArticleReader />} />
          <Route path="/admin/login" element={<Login />} />
          <Route path="/admin" element={<Protected><AdminLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="biblioteca" element={<Library />} />
            <Route path="biblioteca/:id" element={<DocumentDetail />} />
            <Route path="sintesis" element={<SintesisWizard />} />
            <Route path="redactor" element={<Redactor />} />
            <Route path="articulos" element={<Articulos />} />
            <Route path="correo" element={<Correo />} />
            <Route path="agente" element={<AgentLayout />}>
              <Route index element={<AgentOverview />} />
              <Route path="conocimiento" element={<AgentKnowledge />} />
              <Route path="dinamicas" element={<Navigate to="/admin/agente" replace />} />
              <Route path="contactos" element={<AgentContacts />} />
              <Route path="conversaciones" element={<AgentConversations />} />
              <Route path="propuestas" element={<AgentProposals />} />
              <Route path="whatsapp" element={<AgentWhatsApp />} />
              <Route path="probar" element={<AgentSandbox />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
